(ns frontend.view.settings2.state
  (:require [common.localization :as loc]))

(def config-route "config")
(def users-route "users")
(def guest-users-route "guest-users")
(def teams-route "teams")
(def insider-groups-route "insider-groups")
(def security-route "security")
(def zapai-route "zapai")
(def mcp-admin-route "mcp-admin")
(def modules-route "modules")
(def business-route "business")
(def data-route "data")

(def tabs
  [{:key   :config
    :label (loc/tr :settings2/configuration)
    :route config-route}
   {:key   :users
    :label (loc/tr :settings/users)
    :route users-route}
   {:key   :guest-users
    :label (loc/tr :settings/guest-accounts)
    :route guest-users-route}
   {:key   :teams
    :label (loc/tr :settings/teams)
    :route teams-route}
   {:key   :insider-groups
    :label (loc/tr :settings/insider-groups)
    :route insider-groups-route}
   {:key   :security
    :label (loc/tr :security)
    :route security-route}
   {:key   :zapai
    :label (loc/tr :settings2/zapai)
    :route zapai-route}
   {:key   :mcp-admin
    :label (loc/tr :settings2/mcp-admin)
    :route mcp-admin-route}
   {:key   :your-modules
    :label (loc/tr :settings2/your-modules)
    :route modules-route}
   {:key   :your-business
    :label (loc/tr :settings2/your-business)
    :route business-route}
   {:key   :your-data
    :label (loc/tr :settings2/your-data)
    :route data-route}])
